// export const regEmail = new RegExp(/^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$/);
export const regEmail = new RegExp(/^[\w-\\.]+@([\w-]+\.)+[\w-]{2,5}$/);
export const regPassword = new RegExp(
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#$@!%&*?])[A-Za-z\d#$@!%&*?]{8,30}$/
);
export const regPan = new RegExp(/^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/);

export const regIFSC =  new RegExp(/^[A-Z]{4}0[A-Z0-9]{6}$/);

export const amountRegex = /^[0-9]{0,12}([.][0-9]{0,2}){0,1}$/;

/*
 the below regExp is for password validation 
 Min 1 uppercase letter.
 Min 1 lowercase letter.
 Min 1 special character.
 Min 1 number.
 Min 8 characters.
 Max 30 characters.
 /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#$@!%&*?])[A-Za-z\d#$@!%&*?]{8,30}$/;
 */
